(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-lifestyle-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lifestyle-slider')) {
    customElements.define('lifestyle-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.ls-slide')];
        this.dots = [...this.querySelectorAll('.ls-dot')];
        this.index = 0;
        this.speed = Math.max(2000, parseInt(this.dataset.speed, 10) || 6000);
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => dot.addEventListener('click', () => { this.show(parseInt(dot.dataset.go, 10)); this.restart(); }));

        // Men/Women style switch: every slide carries its own copy, so keep focus on the same tab after switching
        this.querySelectorAll('.ls-switch__tab').forEach((tab) => tab.addEventListener('click', () => {
          const target = parseInt(tab.dataset.go, 10);
          this.show(target);
          this.restart();
          const twin = this.slides[target] && this.slides[target].querySelector(`.ls-switch__tab[data-go="${target}"]`);
          if (twin && document.activeElement === tab) twin.focus({ preventScroll: true });
        }));

        // Pause while the visitor is interacting with the section
        this.paused = false;
        const pause = () => { this.paused = true; };
        const resume = () => { this.paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.addEventListener('touchstart', pause, { passive: true });

        if (window.Shopify && window.Shopify.designMode) {
          this.onSelect = (event) => {
            const slide = event.target.closest && event.target.closest('.ls-slide');
            if (slide && this.contains(slide)) { this.show(this.slides.indexOf(slide)); this.stop(); }
          };
          document.addEventListener('shopify:block:select', this.onSelect);
        }

        // Product sliders measure their height once; re-measure whenever an image or font arrives
        // or the window changes size, so names and prices are never cut off
        this.queueResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.resizeSliders(), 120);
        };
        this.addEventListener('load', this.queueResize, true);
        window.addEventListener('resize', this.queueResize);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.queueResize);
        window.addEventListener('load', this.queueResize);

        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.queueResize);
        window.removeEventListener('load', this.queueResize);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      resizeSliders() {
        const Flickity = window.theme && window.theme.Flickity;
        if (!Flickity) return;
        this.querySelectorAll('custom-content-slider').forEach((slider) => {
          const flkty = Flickity.data(slider.querySelector('.flickity-enabled') || slider);
          if (flkty) flkty.resize();
        });
      }

      stop() { clearInterval(this.timer); }

      restart() {
        this.stop();
        if (!this.autoplay) return;
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.show((this.index + 1) % this.slides.length);
        }, this.speed);
      }

      show(i) {
        if (i === this.index || !this.slides[i]) return;
        this.index = i;
        this.slides.forEach((slide, n) => {
          const hidden = n !== i;
          slide.classList.toggle('ls-slide--hidden', hidden);
          if (hidden) slide.setAttribute('aria-hidden', 'true');
          else slide.removeAttribute('aria-hidden');
        });
        this.dots.forEach((dot, n) => dot.setAttribute('aria-selected', String(n === i)));

        // Let the product sliders re-measure themselves
        this.resizeSliders();
        window.dispatchEvent(new Event('resize'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-list-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('list-collections-tabs')) {
    customElements.define('list-collections-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('.lct-tab')];
        this.panels = [...this.querySelectorAll('.lct-panel')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.tab));
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.tabs[next].focus();
            this.activate(this.tabs[next].dataset.tab);
          });
        });

        // Theme editor: selecting a tab or a collection block shows its tab
        if (window.Shopify && window.Shopify.designMode) {
          this.onSelect = (event) => {
            if (!this.contains(event.target)) return;
            if (event.target.matches('.lct-tab')) return this.activate(event.target.dataset.tab);
            const panel = event.target.closest('.lct-panel');
            if (panel) this.activate(panel.dataset.panel);
          };
          document.addEventListener('shopify:block:select', this.onSelect);
        }
      }

      disconnectedCallback() {
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      activate(value) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.tab === value;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const hidden = panel.dataset.panel !== value;
          panel.classList.toggle('lct-panel--hidden', hidden);
          if (hidden) panel.setAttribute('aria-hidden', 'true');
          else panel.removeAttribute('aria-hidden');
        });

        // Let the theme slider re-measure the panel that just became visible
        const slider = this.querySelector(`.lct-panel[data-panel="${value}"] grid-slider`);
        const flickity = slider && window.theme && window.theme.Flickity && window.theme.Flickity.data(slider);
        if (flickity) {
          flickity.resize();
          flickity.select(0, false, true);
        }
        if (slider && typeof slider.setSliderArrowsPosition === 'function') slider.setSliderArrowsPosition(slider);
        const mobileTrack = this.querySelector(`.lct-panel[data-panel="${value}"] .carousel--mobile`);
        if (mobileTrack) mobileTrack.scrollLeft = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
